import React from 'react';

import EnvironmentContext from './EnvironmentContext';

export default function EnvironmentProvider(props)
{
  const [environment, setEnvironment] = React.useState();

  React.useEffect(() => {
    const fetchEnvironment = async () => {
      const response = await fetch("/api/environment");
      const environment = await response.json();
      setEnvironment(environment);
    };

    fetchEnvironment();
  }, []);

  return (
    <EnvironmentContext.Provider value={environment}>
      { environment ?  props.children : null } 
    </EnvironmentContext.Provider>
  );
}